module.exports = __webpack_public_path__ + "img/hr-rock-huge-11.4a5eb269.png";